import React, { useEffect, useState } from "react";
import { SystemConstant } from "const";
import { AvatarGroup } from "components";
import { getInteractor } from "services/local.service";
import {
  NoticeContentText,
  NotificationContent,
  NotificationItem,
  NotificationTime,
  useNotificationStyles,
} from "./component";
import { useDispatch } from "react-redux";
import { ConversationActions } from "redux-store";
import { convertString2JSON, StorageUtil } from "utils";
import { EventSubType } from "pubsub/PubSub.const";

const NotificationOwnerItem = ({ data, ...otherProps }) => {
  const classes = useNotificationStyles();
  const dispatch = useDispatch();
  const prefixKey = StorageUtil.getCurrentPrefixKey();

  const [notification, setNotification] = useState(data);

  const handleClickNotification = async () => {
    const { group_id, sub_type } = convertString2JSON(notification.options, {});
    const group = await getInteractor(prefixKey).LocalGroupService.findById(group_id);

    if (sub_type === EventSubType.ADD_ACCOUNT && group && group.id) {
      dispatch(
        ConversationActions.setSelectGroupId({
          selectedGroupId: group_id,
        }),
      );
    }
  };

  useEffect(() => {
    getInteractor()
      .LocalBranchService.get(data.branchId)
      .then(tmpBranchDetail => {
        if (tmpBranchDetail) setNotification({ ...notification, avatarId: tmpBranchDetail.attachment_id });
      });
  }, [data]);

  const isRead = data.status === SystemConstant.NOTIFICATION_STATUS.read;

  return (
    <NotificationItem className={isRead ? classes.readNotice : ""} onClick={handleClickNotification} {...otherProps}>
      <AvatarGroup avatarId={notification.avatarId} group={{ isServerLogo: true }} />
      <NotificationContent>
        <NoticeContentText
          className="regular-md-txt ellipsis"
          dangerouslySetInnerHTML={{
            __html: notification.content,
          }}
        />
        <NotificationTime created={notification.created} isUnread={!isRead} />
      </NotificationContent>
    </NotificationItem>
  );
};
export default NotificationOwnerItem;
